import { Expose } from 'class-transformer';

export class WarehouseProductManagementResponseDto {
    /**
     * Warehouse product management configuration ID
     * @example '123e4567-e89b-12d3-a456-426614174000'
     */
    @Expose()
    id: string;

    /**
     * Warehouse details ID reference
     * @example '123e4567-e89b-12d3-a456-426614174000'
     */
    @Expose()
    warehouseDetailId: string;

    /**
     * Client Information Record ID
     * @example '123e4567-e89b-12d3-a456-426614174000'
     */
    @Expose()
    clientInformationRecordId: string;

    /**
     * Primary status control method
     * @example 'ElectronicWMS'
     */
    @Expose()
    statusControlPrimary?: string;

    /**
     * Name of WMS system
     * @example 'Robocom customized'
     */
    @Expose()
    wmsSystemName?: string;

    /**
     * SOP/Reference for placard control
     * @example 'W3-02'
     */
    @Expose()
    placardControlRef?: string;

    /**
     * New product setup process
     * @example 'Item setup process description'
     */
    @Expose()
    newProductSetupProcess?: string;

    /**
     * Storage Ambient 15-30C
     * @example true
     */
    @Expose()
    storageAmbient15_30C?: boolean;

    /**
     * Storage Ambient 15-25C
     * @example false
     */
    @Expose()
    storageAmbient15_25C?: boolean;

    /**
     * Storage Cold Chain 2-8C
     * @example true
     */
    @Expose()
    storageColdChain2_8C?: boolean;

    /**
     * Storage Aerosol Cage
     * @example false
     */
    @Expose()
    storageAerosolCage?: boolean;

    /**
     * Storage Controlled Drug Cage
     * @example false
     */
    @Expose()
    storageControlledDrugCage?: boolean;

    /**
     * Description if Other storage is used
     * @example 'Special storage conditions'
     */
    @Expose()
    storageOtherDesc?: string;

    /**
     * Product tracking unit (Unit, Case, EA, ReferToWMS)
     * @example 'Case'
     */
    @Expose()
    productTrackingUnit?: string;

    /**
     * System printouts provided on receipt?
     * @example true
     */
    @Expose()
    wmsScreenshotOnReceipt?: boolean;

    /**
     * System printouts provided on disposition?
     * @example true
     */
    @Expose()
    wmsScreenshotOnDisposition?: boolean;

    /**
     * Has quarantine area
     * @example true
     */
    @Expose()
    hasQuarantineArea?: boolean;

    /**
     * Has cold storage
     * @example true
     */
    @Expose()
    hasColdStorage?: boolean;

    /**
     * Has humidity control
     * @example true
     */
    @Expose()
    hasHumidityControl?: boolean;

    /**
     * Inventory on ZenQMS
     * @example true
     */
    @Expose()
    inventoryOnZenQms?: boolean;

    /**
     * Notes
     * @example 'Additional security measures in place'
     */
    @Expose()
    notes?: string;

    /**
     * Creation timestamp
     * @example '2024-01-15T10:30:00Z'
     */
    @Expose()
    createdAt: Date;

    /**
     * Last update timestamp
     * @example '2024-01-15T10:30:00Z'
     */
    @Expose()
    updatedAt: Date;
}
